import { ChartNoAxesColumn } from 'lucide-react';

import { clsx } from 'clsx';

import { addToComparisonThunk, removeFromComparisonThunk, useComparison } from '@screens/Comparison';
import { RemoveComparison } from '@shared/assets/components/RemoveComparison';
import { ACCENT } from '@shared/constants/colors';
import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { Tooltip } from '@shared/ui/Tooltip';

import cls from './ComparisonButton.module.scss';

type ComparisonButtonProps = {
  className?: string;
  id: string;
  category: string;
};

export const ComparisonButton = ({ className, id, category }: ComparisonButtonProps) => {
  const dispatch = useAppDispatch();
  const productsInComparison = useAppSelector((state) => state.comparison.productIds);
  const productAddedToComparison = productsInComparison.find((el) => el === id);

  const { removeProduct } = useComparison();

  const toggleHandler = async () => {
    if (!productAddedToComparison) {
      dispatch(addToComparisonThunk(id));
      return;
    }

    if (removeProduct) {
      removeProduct(id, category);
    } else {
      dispatch(removeFromComparisonThunk(id));
    }
  };

  return (
    <Tooltip label={productAddedToComparison ? 'Удалить из сравнения' : 'Добавить в сравнение'}>
      <button
        onClick={toggleHandler}
        aria-label={'Добавить в сравнение'}
        className={clsx(cls.wrap, className)}
      >
        <div className={cls.icon}>
          {productAddedToComparison && (
            <div className={cls.remove}>
              <RemoveComparison />
            </div>
          )}
          <div className={cls.main}>
            <ChartNoAxesColumn color={ACCENT} />
          </div>
        </div>
      </button>
    </Tooltip>
  );
};
